import React from "react";
import { useLocation } from "react-router-dom";
import { IoBookOutline } from "react-icons/io5";
import { IoIosHelpCircleOutline } from "react-icons/io";
import { useTranslation } from "react-i18next";
import {
  RiFolderLine,
  RiSettings5Line,
  RiLogoutBoxRLine,
} from "react-icons/ri";
import { VscFeedback, VscInfo, VscListUnordered } from "react-icons/vsc";
import { PiUserList } from "react-icons/pi";
import {
  Col,
  Nav,
  NavDropdown,
  Offcanvas,
  Placeholder,
  Row,
} from "react-bootstrap";
import { NavLinkWithLocale } from "../index";
import style from "./HeaderBar.module.css";

const DesktopMenu = ({ user, loading, handleLogOut, actualLocation }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const pathName = location.pathname.split("/").slice(2).join("/");
  const isUserHome = pathName === "userHome";

  return (
    <Offcanvas.Body>
      <Nav className={`ms-4 ms-xl-5 ${style.offcanvasNav}`}>
        <Row
          className={`align-items-center ${
            isUserHome ? style.offcanvasUserNav : style.offcanvasNav
          }`}
        >
          {!isUserHome && (
            <Col md="auto" className="m-0 p-0">
              {!user && (
                <NavLinkWithLocale
                  className={`${style.links} ${
                    actualLocation === `/${i18n.language}/product`
                      ? style.activeLink
                      : ""
                  }`}
                  to="/product"
                >
                  {t("Plans & Pricing")}
                </NavLinkWithLocale>
              )}
            </Col>
          )}
          <Col md={loading ? 12 : "auto"} xl={9} className="m-0 p-0">
            <Row className={`p-0 m-0 align-items-center justify-content-end`}>
              {!isUserHome && (
                <>
                  {!user && (
                    <Col md="auto" className={style.bgIconMatch}>
                      <NavLinkWithLocale
                        className={style.links}
                        to="/colormatch"
                      >
                        {t("Match Colors")}
                      </NavLinkWithLocale>
                    </Col>
                  )}
                  <Col md="auto" className={style.bgIconSearch}>
                    <NavLinkWithLocale className={style.links} to="/search">
                      {t("Search Balloons")}
                    </NavLinkWithLocale>
                  </Col>
                </>
              )}
              {loading ? (
                <>
                  <Col className="p-0 m-0" md={1}>
                    <Placeholder animation="glow">
                      <Placeholder
                        xs={10}
                        size="sm"
                        style={{ borderRadius: "10px" }}
                      />
                    </Placeholder>
                  </Col>
                  <Col className="p-0 m-0" md={1}>
                    <Placeholder animation="glow">
                      <Placeholder
                        xs={10}
                        size="sm"
                        style={{ borderRadius: "10px" }}
                      />
                    </Placeholder>
                  </Col>
                </>
              ) : user ? (
                <>
                  {!isUserHome && (
                    <>
                      <Col
                        className={`p-0 m-0 ${style.navMenuItem} ${style.bgIconMatch}`}
                        md="auto"
                      >
                        <NavLinkWithLocale
                          className={`${style.links} ${
                            actualLocation === `/${i18n.language}/colormatch`
                              ? style.activeLink
                              : ""
                          }`}
                          to="/colormatch"
                        >
                          {t("Workspace")}
                        </NavLinkWithLocale>
                      </Col>
                      {user.role === "1" && (
                        <Col
                          className={`p-0 m-0 ${style.navMenuItem}`}
                          md="auto"
                        >
                          <NavLinkWithLocale
                            className={style.userHomeLinks}
                            to="/dashboard"
                          >
                            Dashboard
                          </NavLinkWithLocale>
                        </Col>
                      )}
                    </>
                  )}
                  {/* HELP DROPDOWN */}
                  <Col className="p-0 m-0" md="auto">
                    <NavDropdown
                      title={
                        <>
                          <IoIosHelpCircleOutline size="1.5rem" /> {t("Help")}
                        </>
                      }
                      className={style.userHomeLinks}
                      align={{ lg: "end" }}
                    >
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/sendFeedback"
                        className={style.userOptions}
                      >
                        <VscFeedback size="1rem" />
                        {t("Feedback")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/reportAnIssue"
                        className={style.userOptions}
                      >
                        <VscInfo size="1rem" />
                        {t("Report an Issue")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/supportedBrands"
                        className={style.userOptions}
                      >
                        <VscListUnordered size="1rem" />
                        {t("Supported Brands")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/product"
                        className={style.userOptions}
                      >
                        <PiUserList size="1rem" />
                        {t("Plans & Pricing")}
                      </NavDropdown.Item>
                      {/* <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="#"
                        className={style.userOptions}
                      >
                        <IoBookOutline size="1rem" />
                        {t("FAQ")}
                      </NavDropdown.Item> */}
                    </NavDropdown>
                  </Col>
                  {/* USER DROPDOWN */}
                  <Col className="p-0 m-0" md="auto">
                    <NavDropdown
                      title={
                        <>
                          <div className={style.userDropdown}>
                            {user.name[0]}
                          </div>
                          <p style={{ display: "inline" }}>{user.name}</p>
                        </>
                      }
                      className={style.userHomeLinks}
                      align={{ lg: "end" }}
                    >
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/profile/palettes"
                        className={style.userOptions}
                      >
                        <RiFolderLine size="1rem" />
                        {t("Saved Palettes")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/profile"
                        className={style.userOptions}
                      >
                        <RiSettings5Line size="1.1rem" />
                        {t("Account Settings")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        onClick={handleLogOut}
                        className={style.userOptions}
                      >
                        <RiLogoutBoxRLine size="1rem" />
                        {t("Log out")}
                      </NavDropdown.Item>
                      <NavDropdown.Divider className={style.dropdownDivider} />
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/terms"
                        className={style.sublinks}
                      >
                        {t("Terms")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/privacyPolicy"
                        className={style.sublinks}
                      >
                        {t("Privacy Policy")}
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={NavLinkWithLocale}
                        to="/contactUs"
                        className={style.sublinks}
                      >
                        {t("Contact Us")}
                      </NavDropdown.Item>
                    </NavDropdown>
                  </Col>
                </>
              ) : (
                <>
                  <Col className={`p-0 m-0 ${style.navMenuItem}`} md="auto">
                    <NavLinkWithLocale
                      className={`${style.links} ${style.differentLink} ${
                        actualLocation === `/${i18n.language}/createAccount`
                          ? style.activeLink
                          : ""
                      }`}
                      to="/createAccount"
                    >
                      {t("Sign Up")}
                    </NavLinkWithLocale>
                  </Col>
                  <Col className={`p-0 m-0 ${style.navMenuItem}`} md="auto">
                    <NavLinkWithLocale
                      className={`${style.links} ${
                        actualLocation === `/${i18n.language}/login`
                          ? style.activeLink
                          : ""
                      }`}
                      to="/login"
                    >
                      {t("Log In")}
                    </NavLinkWithLocale>
                  </Col>
                </>
              )}
              {/* {!isUserHome && (
                <Col className={`p-0 m-0 ${style.navMenuItem}`} md="auto">
                  <LanguageSwitcher drop="down" position="header" />
                </Col>
              )} */}
            </Row>
          </Col>
        </Row>
      </Nav>
    </Offcanvas.Body>
  );
};

export default DesktopMenu;
